import { VorlageStationSheet } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateVorlageStation/components/VorlageStationSheet';
import { useForm } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateVorlageStation/useForm';
import {
  type RotationsplanVorlageDetails,
  useRotationsplanVorlageById,
} from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplanVorlageById/useRotationsplanVorlageById';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

const VORLAGEN_PATH = '/mitarbeiter/rotationsplaene/vorlagen';

export function CreateVorlageStation() {
  const { vorlageId, abschnittId } = useParams();
  const { vorlage } = useRotationsplanVorlageById(vorlageId ?? '');
  const navigate = useNavigate();

  const abschnitt = vorlage?.abschnitte.find(({ id }) => id === abschnittId);

  if (!vorlage || !abschnitt) {
    return <Navigate to={VORLAGEN_PATH} replace />;
  }

  return (
    <CreateVorlageStationSheet
      vorlage={vorlage}
      vorlageAbschnittId={abschnitt.id}
      close={() =>
        navigate(`${VORLAGEN_PATH}/${vorlage.id}`, { replace: true })
      }
    />
  );
}

// eigene Komponente, damit useForm nur mit geladener Vorlage aufgerufen wird
function CreateVorlageStationSheet({
  vorlage,
  vorlageAbschnittId,
  close,
}: {
  vorlage: RotationsplanVorlageDetails;
  vorlageAbschnittId: string;
  close: () => void;
}) {
  const { t } = useTranslation();
  const { currentStandort } = useStandortContext();
  const form = useForm({
    vorlage,
    vorlageAbschnittId,
    currentStandort,
  });

  return (
    <VorlageStationSheet
      titel={t('domain.mitarbeiter.rotationsplan.vorlagen.createStation.titel')}
      vorlage={vorlage}
      form={form}
      close={close}
    />
  );
}
